export default __webpack_public_path__ + "static/media/RUNNING.BRAND.JDIS_10K.bf93a15f.jpg";